import { DriverAnalysis } from '../types'

export function EventsTab({ analysis }: { analysis: DriverAnalysis }) {
  const { events } = analysis

  if (events.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-sm font-semibold text-gray-500">No Events or Faults</h3>
        <p className="text-gray-400 text-sm mt-1">No events or faults recorded on this driver card.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500">Events & Faults ({events.length})</h3>
      </div>
      <div className="border border-gray-200 rounded overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-500">Date / Time</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-500">Event Type</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-500">Code</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-500">Description</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-500">Vehicle</th>
              <th className="text-center py-2 px-3 text-xs font-semibold text-gray-500">Severity</th>
            </tr>
          </thead>
          <tbody>
            {events.map((evt, i) => (
              <tr key={i} className={`border-b border-gray-100 ${
                evt.severity === 'fault' ? 'bg-red-50/30' :
                evt.severity === 'warning' ? 'bg-amber-50/30' : ''
              }`}>
                <td className="py-2 px-3 text-gray-700 whitespace-nowrap">
                  <span className="font-mono text-xs">
                    {evt.begin_time ? new Date(evt.begin_time).toLocaleDateString('en-GB', {
                      day: '2-digit', month: 'short', year: 'numeric',
                    }) : '—'}
                  </span>
                  <span className="text-gray-400 ml-1.5 font-mono text-xs">
                    {evt.begin_time ? new Date(evt.begin_time).toLocaleTimeString('en-GB', {
                      hour: '2-digit', minute: '2-digit',
                    }) : ''}
                  </span>
                  {evt.end_time && (
                    <span className="text-gray-300 ml-1 font-mono text-xs">
                      — {new Date(evt.end_time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  )}
                </td>
                <td className="py-2 px-3 font-medium text-gray-900 text-xs">{evt.event_type}</td>
                <td className="py-2 px-3 font-mono text-xs text-gray-400">{evt.event_code || '—'}</td>
                <td className="py-2 px-3 text-gray-600 text-xs">{evt.description || '—'}</td>
                <td className="py-2 px-3 font-mono text-xs text-gray-500">{evt.vehicle_registration || '—'}</td>
                <td className="py-2 px-3 text-center">
                  <span className={`inline-block w-2 h-2 rounded-full ${
                    evt.severity === 'fault' ? 'bg-red-500' :
                    evt.severity === 'warning' ? 'bg-amber-500' : 'bg-blue-400'
                  }`} />
                  <span className={`text-xs ml-1.5 ${
                    evt.severity === 'fault' ? 'text-red-600 font-medium' :
                    evt.severity === 'warning' ? 'text-amber-600' : 'text-gray-400'
                  }`}>{evt.severity}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
